<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp" :sticky="sticky">
    <ProjectSchemesTableItem
      v-for="(item, key) in items"
      :key="key"
      :itemKey="key"
      :item="item"
      :edit="edit"
      :schemeTypeList="schemeTypeList"
      :schemeClassList="schemeClassList"
      :workAreaList="workAreaList"
      @itemData="onItemData"
      :editShowPage="editShowPage"
    />
    <ProjectSchemesTableItem
      v-for="(item, key) in itemsUpload"
      :key="'download' + key"
      :item="item"
      :upload="true"
    />
  </BaseTableView>
</template>

<script>
import _ from 'lodash'
import ProjectSchemesTableItem from 'components/project/schemesAndDocuments/schemes/ProjectSchemesTableItem'
import BaseTableView from "components/base/tableview/BaseTableView";

export default {
  name: 'ProjectSchemesTable',
  props: {
    items: Array,
    itemsUpload: Array,
    edit: Boolean,
    editShowPage: Boolean,
    schemeTypeList: Array,
    schemeClassList: Array,
    workAreaList: Array,
    sticky: Boolean
  },
  components: {BaseTableView, ProjectSchemesTableItem},
  data() {
    return {
      schemesData: [],
      tableMin: false,
    }
  },
  computed: {
    t() {
      return this.localStorage.translations.pages['sales_project']['schemes_documents-tables']
    },
    tableHead() {
      return [
        {text: this.t['nazvanie']},
        {text: this.t['tip-chertezha']},
        {text: this.t['data']},
        {text: this.t['soderzhanie']},
        {text: this.t['zona-raboty']},
        {text: '', active: true},
      ]
    },
  },
  methods: {
    onItemData(value) {
      const itemKey = value.key
      if (this.schemesData[itemKey]) {
        this.schemesData[itemKey] = value.data
      } else {
        this.schemesData.push(value.data)
      }
      if (this.schemesData.length == this.items.length) {
        value.data = this.schemesData
        this.$emit('schemesTableData', value)
      }
    },
    onMin(value) {
      this.tableMin = value
    },
  },
  watch: {
    edit() {
      if (!this.edit) {
        this.schemesData = []
      }
    },
  },
}
</script>
